/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// DO NOT MODIFY
// FILE GENERATED BY `intl-codegen@2.2.1`
// https://github.com/eversport/intl-codegen
// DO NOT MODIFY

export default context => {
  const formatter_0 = context.m({});
  const formatter_1 = context.d({ day: "numeric", month: "long", year: "numeric" });

  return [
    // `accepted-invitation-token`:
    // This invitation link has already been accepted.
    params => "" +
      "This invitation link has already been accepted.",

    // `android-label`:
    // Android
    params => "" +
      "Android",

    // `app_promotion_message`:
    // Download the Eversports app now!
    params => "" +
      "Download the Eversports app now!",

    // `app-promotion-subtext`:
    // We use Eversports
    params => "" +
      "We use Eversports",

    // `authentication-account-already-exists`:
    // Already have an account?
    params => "" +
      "Already have an account?",

    // `authentication-create-an-account-message`:
    // Create an account
    params => "" +
      "Create an account",

    // `authentication-facebook-pop-up-blocker-disclaimer`:
    // In order to use facebook, you might have to enable pop-ups for this site in your browser settings
    params => "" +
      "In order to use facebook, you might have to enable pop-ups for this site in your browser settings",

    // `authentication-forgot-password-action`:
    // Send reset link
    params => "" +
      "Send reset link",

    // `authentication-forgot-password-back-to-login`:
    // Back to login
    params => "" +
      "Back to login",

    // `authentication-forgot-password-description`:
    // Enter the email address associated with your account, and we’ll email you a link to reset your password
    params => "" +
      "Enter the email address associated with your account, and we’ll email you a link to reset your password",

    // `authentication-forgot-password-email-label`:
    // Email address
    params => "" +
      "Email address",

    // `authentication-forgot-password-heading`:
    // Forgot Password?
    params => "" +
      "Forgot Password?",

    // `authentication-login-action`:
    // Login
    params => "" +
      "Login",

    // `authentication-login-email-label`:
    // Email
    params => "" +
      "Email",

    // `authentication-login-password-label`:
    // Password
    params => "" +
      "Password",

    // `authentication-login-separator-text`:
    // or
    params => "" +
      "or",

    // `authentication-login-welcome-message`:
    // Welcome back!
    params => "" +
      "Welcome back!",

    // `authentication-login-with-facebook-action`:
    // Continue With Facebook
    params => "" +
      "Continue With Facebook",

    // `authentication-login-with-google-action`:
    // Continue with Google
    params => "" +
      "Continue with Google",

    // `authentication-no-account-yet`:
    // No account yet?
    params => "" +
      "No account yet?",

    // `authentication-registration-action`:
    // Register
    params => "" +
      "Register",

    // `authentication-registration-continue-with-email`:
    // Continue with email
    params => "" +
      "Continue with email",

    // `authentication-registration-email-label`:
    // Email
    params => "" +
      "Email",

    // `authentication-registration-firstname-label`:
    // First Name
    params => "" +
      "First Name",

    // `authentication-registration-lastname-label`:
    // Last Name
    params => "" +
      "Last Name",

    // `authentication-registration-password-label`:
    // Password
    params => "" +
      "Password",

    // `authentication-registration-toggle-sign-up`:
    // Sign up
    params => "" +
      "Sign up",

    // `back`:
    // Back
    params => "" +
      "Back",

    // `company-details-confirmation`:
    // To the booking page
    params => "" +
      "To the booking page",

    // `company-details-header`:
    // Your online account at Eversports is now activated.
    params => "" +
      "Your online account at Eversports is now activated.",

    // `company-details-subheader`:
    // Start your first booking now:
    params => "" +
      "Start your first booking now:",

    // `company-details-text`:
    // Select a facility below to continue.
    params => "" +
      "Select a facility below to continue.",

    // `company-newsletter-subscription-text`:
    // Subscribe to the newsletter and never miss any updates or news of {venueName}!
    params => "" +
      "Subscribe to the newsletter and never miss any updates or news of " +
      params.venueName +
      "!",

    // `company-newsletter-subscription-title`:
    // Be part of the community!
    params => "" +
      "Be part of the community!",

    // `consent-form-token-invalid-error`:
    // An unexpected error happened. Please try to register again under the following Link:
    params => "" +
      "An unexpected error happened. Please try to register again under the following Link:",

    // `consent-form-token-invalid-error-link`:
    // Retry registration
    params => "" +
      "Retry registration",

    // `cookie-banner-accept-all`:
    // Accept all
    params => "" +
      "Accept all",

    // `cookie-banner-confirm`:
    // Confirm selection
    params => "" +
      "Confirm selection",

    // `cookie-banner-cookie-preferences`:
    // Cookie preferences
    params => "" +
      "Cookie preferences",

    // `cookie-banner-description-long`:
    // We use cookies so that we can offer you the best possible website experience. You are free to decide which categories you would like to permit. You can edit your cookie settings at any time by going to the home page and selecting "Cookie Settings" at the bottom of the page.
    params => "" +
      "We use cookies so that we can offer you the best possible website experience. You are free to decide which categories you would like to permit. You can edit your cookie settings at any time by going to the home page and selecting \"Cookie Settings\" at the bottom of the page.",

    // `cookie-banner-description-short`:
    // We use cookies so that we can offer you the best possible website experience. You are free to decide which categories you would like to permit. You can edit your cookie settings at any time.
    params => "" +
      "We use cookies so that we can offer you the best possible website experience. You are free to decide which categories you would like to permit. You can edit your cookie settings at any time.",

    // `cookie-banner-further-information`:
    // Further information regarding cookies and privacy policies at Eversports can be found in the {privacyPolicy} . Details regarding how we store cookies can be found in the {technicalNotes}
    params => [
      "Further information regarding cookies and privacy policies at Eversports can be found in the ",
      params.privacyPolicy,
      " . Details regarding how we store cookies can be found in the ",
      params.technicalNotes,
    ],

    // `cookie-banner-label-advertising`:
    // Advertising Cookies
    params => "" +
      "Advertising Cookies",

    // `cookie-banner-label-advertising-description`:
    // In order to track the performance of advertising efforts and ensure more personalised advertising, this site uses Google Analytics, Google Tag Manager, and Google Ads, which are solutions operated by Google LLC based in California, USA and use third-party tags. Personal data, such as IP address, might be processed.
    params => "" +
      "In order to track the performance of advertising efforts and ensure more personalised advertising, this site uses Google Analytics, Google Tag Manager, and Google Ads, which are solutions operated by Google LLC based in California, USA and use third-party tags. Personal data, such as IP address, might be processed.",

    // `cookie-banner-label-analytics`:
    // Analytics Cookies
    params => "" +
      "Analytics Cookies",

    // `cookie-banner-label-analytics-description`:
    // In order to continuously improve our website, we anonymously track data for statistical and analytical purposes. With these cookies we can, for example, track the number of visits or the impact of specific pages of our web presence and therefore optimize our content.
    params => "" +
      "In order to continuously improve our website, we anonymously track data for statistical and analytical purposes. With these cookies we can, for example, track the number of visits or the impact of specific pages of our web presence and therefore optimize our content.",

    // `cookie-banner-label-necessary`:
    // Necessary Cookies
    params => "" +
      "Necessary Cookies",

    // `cookie-banner-label-necessary-description`:
    // These cookies are necessary to run the core functionalities of this website, e.g. security related functions. With these cookies we can also detect if you want to stay logged into your profile to provide you with fast access to our services after revisiting our website.
    params => "" +
      "These cookies are necessary to run the core functionalities of this website, e.g. security related functions. With these cookies we can also detect if you want to stay logged into your profile to provide you with fast access to our services after revisiting our website.",

    // `cookie-banner-privacy-policy`:
    // privacy policy
    params => "" +
      "privacy policy",

    // `cookie-banner-technical-notes`:
    // technical notes
    params => "" +
      "technical notes",

    // `cookie-banner-title`:
    // Cookie Settings
    params => "" +
      "Cookie Settings",

    // `corporate-budget-disclaimer`:
    // I am aware that whenever I use my benefits (budget or exclusive discounts) booking information will be shared with my organization.* ({corporatePartnerName})
    params => "" +
      "I am aware that whenever I use my benefits (budget or exclusive discounts) booking information will be shared with my organization.* (" +
      params.corporatePartnerName +
      ")",

    // `corporate-budget-shared-information-amount`:
    // Amount of Budget used
    params => "" +
      "Amount of Budget used",

    // `corporate-budget-shared-information-data-protection-link`:
    // All other data protection and information can be found in the {link}
    params => [
      "All other data protection and information can be found in the ",
      params.link,
    ],

    // `corporate-budget-shared-information-date`:
    // Date of booking
    params => "" +
      "Date of booking",

    // `corporate-budget-shared-information-email`:
    // Your E-Mail address
    params => "" +
      "Your E-Mail address",

    // `corporate-budget-shared-information-header`:
    // *) Whenever you use your benefits (budget or exclusive discounts) the following booking information will be shared with your organization:
    params => "" +
      "*) Whenever you use your benefits (budget or exclusive discounts) the following booking information will be shared with your organization:",

    // `corporate-budget-shared-information-legal-basis`:
    // Legal basis: performance of contract
    params => "" +
      "Legal basis: performance of contract",

    // `corporate-budget-shared-information-name`:
    // Your Name
    params => "" +
      "Your Name",

    // `corporate-budget-shared-information-purpose`:
    // Purpose: Settlement of services between Eversports and {corporatePartnerName}
    params => "" +
      "Purpose: Settlement of services between Eversports and " +
      params.corporatePartnerName,

    // `corporate-invitation-text-budget`:
    // {corporatePartnerName} will be covering up to {amount} per {interval, select, 
    //  WEEK {week} 
    //  MONTH {month} 
    //  other {year}} of your bookings!
    params => "" +
      params.corporatePartnerName +
      " will be covering up to " +
      formatter_0(params.amount) +
      " per " +
      (
        params.interval == "WEEK" ? "" +
          "week" :
        params.interval == "MONTH" ? "" +
          "month" :
        "" +
          "year"
      ) +
      " of your bookings!",

    // `corporate-invitation-text-budget-expiry`:
    // You can use this budget until {expiry, date, long}.
    params => "" +
      "You can use this budget until " +
      formatter_1(params.expiry) +
      ".",

    // `corporate-invitation-text-budget-general`:
    // {corporatePartnerName} is providing you with a budget to pay for your bookings!
    params => "" +
      params.corporatePartnerName +
      " is providing you with a budget to pay for your bookings!",

    // `corporate-invitation-text-budget-once`:
    // {corporatePartnerName} will be covering up to {amount} of your bookings!
    params => "" +
      params.corporatePartnerName +
      " will be covering up to " +
      formatter_0(params.amount) +
      " of your bookings!",

    // `corporate-invitation-text-discounts`:
    // {corporatePartnerName} is providing you with access to exclusive company discounts at many venues!
    params => "" +
      params.corporatePartnerName +
      " is providing you with access to exclusive company discounts at many venues!",

    // `corporate-invitation-text-intro`:
    // {corporatePartnerName} is part of the Eversports corporate sports program. Register or log in and claim your benefits to book your favourite sports online!
    params => "" +
      params.corporatePartnerName +
      " is part of the Eversports corporate sports program. Register or log in and claim your benefits to book your favourite sports online!",

    // `corporate-partner-title`:
    // {corporatePartnerName} now has a partnership with Eversports
    params => "" +
      params.corporatePartnerName +
      " now has a partnership with Eversports",

    // `corporate-partner-voucher-code-label`:
    // Voucher Code
    params => "" +
      "Voucher Code",

    // `create-family-account`:
    // Create a family account
    params => "" +
      "Create a family account",

    // `date_unit_day`:
    // day
    params => "" +
      "day",

    // `date_unit_day_plural`:
    // Days
    params => "" +
      "Days",

    // `date_unit_game`:
    // Game
    params => "" +
      "Game",

    // `date_unit_game_plural`:
    // Games
    params => "" +
      "Games",

    // `date_unit_hour`:
    // Hours
    params => "" +
      "Hours",

    // `date_unit_hour_plural`:
    // Hours
    params => "" +
      "Hours",

    // `date_unit_minute`:
    // minute
    params => "" +
      "minute",

    // `date_unit_minute_plural`:
    // Minutes
    params => "" +
      "Minutes",

    // `date_unit_month`:
    // month
    params => "" +
      "month",

    // `date_unit_month_plural`:
    // Months
    params => "" +
      "Months",

    // `date_unit_season`:
    // season
    params => "" +
      "season",

    // `date_unit_season_plural`:
    // seasons
    params => "" +
      "seasons",

    // `date_unit_unit`:
    // unit
    params => "" +
      "unit",

    // `date_unit_unit_plural`:
    // Sessions
    params => "" +
      "Sessions",

    // `date_unit_week`:
    // week
    params => "" +
      "week",

    // `date_unit_week_plural`:
    // weeks
    params => "" +
      "weeks",

    // `date_unit_weekend`:
    // weekend
    params => "" +
      "weekend",

    // `date_unit_weekend_plural`:
    // weekends
    params => "" +
      "weekends",

    // `date_unit_year`:
    // year
    params => "" +
      "year",

    // `date_unit_year_plural`:
    // years
    params => "" +
      "years",

    // `email-verification-header-error`:
    // Verification failed
    params => "" +
      "Verification failed",

    // `email-verification-header-success`:
    // Verification successful
    params => "" +
      "Verification successful",

    // `email-verification-text-error`:
    // The email verification failed. Probably your activation link is already expired. Please request a new confirmation email.
    params => "" +
      "The email verification failed. Probably your activation link is already expired. Please request a new confirmation email.",

    // `email-verification-text-success`:
    // The email verification was successful.
    params => "" +
      "The email verification was successful.",

    // `email-verification-text-success-action`:
    // Go to Eversports
    params => "" +
      "Go to Eversports",

    // `email-verification-text-success-action-checkout`:
    // Continue with the booking
    params => "" +
      "Continue with the booking",

    // `email-verification-text-success-action-corporate`:
    // Discover Offers Now 
    params => "" +
      "Discover Offers Now ",

    // `email-verification-text-success-action-widget`:
    // Back to {venueName}
    params => "" +
      "Back to " +
      params.venueName,

    // `eversports`:
    // Eversports
    params => "" +
      "Eversports",

    // `eversports-and-venue-consent-form-consent-agreement-header`:
    // Terms of {venueName}:
    params => "" +
      "Terms of " +
      params.venueName +
      ":",

    // `eversports-and-venue-consent-form-consent-agreement-text`:
    // I read the {policies} of {venueName} and accept the {terms} of {venueName}.
    params => [
      "I read the ",
      params.policies,
      " of ",
      params.venueName,
      " and accept the ",
      params.terms,
      " of ",
      params.venueName,
      ".",
    ],

    // `eversports-and-venue-consent-form-ending`:
    // When you book online, {venueName} gets the contact information (name, email, date of birth, address, profile picture) from your Eversports profile to process your bookings. Eversports gets information about your bookings and products from {venueName} to display them in your Eversports account.
    params => "" +
      "When you book online, " +
      params.venueName +
      " gets the contact information (name, email, date of birth, address, profile picture) from your Eversports profile to process your bookings. Eversports gets information about your bookings and products from " +
      params.venueName +
      " to display them in your Eversports account.",

    // `eversports-and-venue-consent-form-intro`:
    // To create an online account at {venueName}, please accept the terms of {venueName} and the terms of the sportplattform Eversports.
    params => "" +
      "To create an online account at " +
      params.venueName +
      ", please accept the terms of " +
      params.venueName +
      " and the terms of the sportplattform Eversports.",

    // `eversports-consent-form-confirm`:
    // Confirm
    params => "" +
      "Confirm",

    // `eversports-consent-form-consent-text`:
    // Terms of Eversports:
    // I accept the general {terms} of Eversports and I have read the {policies}.
    params => [
      "Terms of Eversports:\nI accept the general ",
      params.terms,
      " of Eversports and I have read the ",
      params.policies,
      ".",
    ],

    // `eversports-consent-form-decline`:
    // Decline
    params => "" +
      "Decline",

    // `eversports-consent-form-heading`:
    // Before we continue …
    params => "" +
      "Before we continue …",

    // `eversports-consent-form-intro`:
    // Our mission is to provide a platform for everyone to find and book sports online - anytime and anywhere. To provide you with a great experience while visiting our website or using our app we collect and process data. The security of your data is very important to us. Information on all our data processing activities is provided in our privacy policy. Please take a look at our privacy policy and our general terms before you continue with your registration.
    params => "" +
      "Our mission is to provide a platform for everyone to find and book sports online - anytime and anywhere. To provide you with a great experience while visiting our website or using our app we collect and process data. The security of your data is very important to us. Information on all our data processing activities is provided in our privacy policy. Please take a look at our privacy policy and our general terms before you continue with your registration.",

    // `eversports-consent-form-modal-heading`:
    // It's not too late ...
    params => "" +
      "It's not too late ...",

    // `eversports-consent-form-modal-text`:
    // By refusing to accept our terms and services policies, you will not be able to use Eversports. If you want to use Eversports please accept our general terms and privacy policy.
    params => "" +
      "By refusing to accept our terms and services policies, you will not be able to use Eversports. If you want to use Eversports please accept our general terms and privacy policy.",

    // `eversports-consent-form-privacy-policies`:
    // privacy policy
    params => "" +
      "privacy policy",

    // `eversports-consent-form-terms-of-service`:
    // general terms
    params => "" +
      "general terms",

    // `eversports-data-protection-declaration`:
    // Eversports data protection declaration
    params => "" +
      "Eversports data protection declaration",

    // `eversports-newsletter`:
    // I want to get news and promotions from Eversports via email.
    params => "" +
      "I want to get news and promotions from Eversports via email.",

    // `expired-invitation-token`:
    // This invitation link has already been expired.
    params => "" +
      "This invitation link has already been expired.",

    // `family-account-already-exists`:
    // You already have a family account
    params => "" +
      "You already have a family account",

    // `family-account-disclaimer-all-purchases`:
    // all purchases
    params => "" +
      "all purchases",

    // `family-account-disclaimer-billed-to-account-owner`:
    // billed to the account owner
    params => "" +
      "billed to the account owner",

    // `family-account-disclaimer-go-back`:
    // Go back
    params => "" +
      "Go back",

    // `family-account-disclaimer-manage-their-bookings`:
    // manage their bookings through one account
    params => "" +
      "manage their bookings through one account",

    // `family-account-disclaimer-text`:
    // With a family account, all your family members can {manageTheirBookings}. Additionally, {allPurchases} that are done by any family member are {billedToAccountOwner}.
    params => [
      "With a family account, all your family members can ",
      params.manageTheirBookings,
      ". Additionally, ",
      params.allPurchases,
      " that are done by any family member are ",
      params.billedToAccountOwner,
      ".",
    ],

    // `family-account-disclaimer-title`:
    // One account for your whole family
    params => "" +
      "One account for your whole family",

    // `family-account-divider-text`:
    // Or
    params => "" +
      "Or",

    // `family-invitation-eversports-info`:
    // By accepting this invitation, you will be able to use your Eversports account to book sports online.
    params => "" +
      "By accepting this invitation, you will be able to use your Eversports account to book sports online.",

    // `family-invitation-go-back`:
    // Go to Eversports
    params => "" +
      "Go to Eversports",

    // `family-invitation-shared-info`:
    // Eversports gets information about your bookings and products to display them in your Eversports account.
    params => "" +
      "Eversports gets information about your bookings and products to display them in your Eversports account.",

    // `family-invitation-venue-info`:
    // When you book online, the venue gets your contact information (name, e-mail, date of birth, address, profile picture) from your Eversports profile to process your bookings.
    params => "" +
      "When you book online, the venue gets your contact information (name, e-mail, date of birth, address, profile picture) from your Eversports profile to process your bookings.",

    // `forgot-password-title`:
    // Forgot Password - Eversports
    params => "" +
      "Forgot Password - Eversports",

    // `general-error`:
    // An unexpected error occurred
    params => "" +
      "An unexpected error occurred",

    // `invalid-corporate-invitation`:
    // This invitation link seems to be invalid or has already been claimed.
    params => "" +
      "This invitation link seems to be invalid or has already been claimed.",

    // `invalid-invitation-token`:
    // This invitation link is not valid or has already been used to verify an account.
    params => "" +
      "This invitation link is not valid or has already been used to verify an account.",

    // `invitation-listed-venues`:
    // the listed venues
    params => "" +
      "the listed venues",

    // `invitation-modal-heading`:
    // It's not too late ...
    params => "" +
      "It's not too late ...",

    // `invitation-modal-text`:
    // By refusing to accept the terms and services policies of Eversports and {venueName}, you will not be able to book online. If you want to book online please accept our general terms and privacy policy.
    params => "" +
      "By refusing to accept the terms and services policies of Eversports and " +
      params.venueName +
      ", you will not be able to book online. If you want to book online please accept our general terms and privacy policy.",

    // `invitation-success-button`:
    // Explore all our offers in the marketplace
    params => "" +
      "Explore all our offers in the marketplace",

    // `invitation-success-header`:
    // Congratulations!
    params => "" +
      "Congratulations!",

    // `invitation-success-text`:
    // You are now a member of Eversports!
    params => "" +
      "You are now a member of Eversports!",

    // `iOS-label`:
    // iOS
    params => "" +
      "iOS",

    // `login-meta-description`:
    // Login to book your next sport activity in {countryName}.
    params => "" +
      "Login to book your next sport activity in " +
      params.countryName +
      ".",

    // `login-meta-title`:
    // Login - Eversports - {countryName}
    params => "" +
      "Login - Eversports - " +
      params.countryName,

    // `login-title`:
    // Login - Eversports
    params => "" +
      "Login - Eversports",

    // `month`:
    // month
    params => "" +
      "month",

    // `next`:
    // Continue
    params => "" +
      "Continue",

    // `no`:
    // No
    params => "" +
      "No",

    // `password-reset-button`:
    // Reset Password
    params => "" +
      "Reset Password",

    // `password-reset-header`:
    // Set a new Password
    params => "" +
      "Set a new Password",

    // `password-reset-requested-header`:
    // Almost there!
    params => "" +
      "Almost there!",

    // `password-reset-requested-text`:
    // Please check your email to complete the password reset.
    params => "" +
      "Please check your email to complete the password reset.",

    // `password-reset-success-button`:
    // Let's go!
    params => "" +
      "Let's go!",

    // `password-reset-success-header`:
    // Success!
    params => "" +
      "Success!",

    // `password-reset-success-text`:
    // Your password was reset.
    params => "" +
      "Your password was reset.",

    // `payment_unit_euro`:
    // Euro
    params => "" +
      "Euro",

    // `privacy-policy`:
    // privacy policy
    params => "" +
      "privacy policy",

    // `registration-meta-description`:
    // Discover sport activities throughout {countryName}. Sign up today to easily book online.
    params => "" +
      "Discover sport activities throughout " +
      params.countryName +
      ". Sign up today to easily book online.",

    // `registration-meta-title`:
    // Registration - Eversports - {countryName}
    params => "" +
      "Registration - Eversports - " +
      params.countryName,

    // `registration-success-action`:
    // Continue
    params => "" +
      "Continue",

    // `registration-success-header`:
    // Almost there!
    params => "" +
      "Almost there!",

    // `registration-success-text`:
    // To complete your registration you just need to verify your email address. You'll receive an email with more information shortly.
    params => "" +
      "To complete your registration you just need to verify your email address. You'll receive an email with more information shortly.",

    // `registration-success-title`:
    // Registration successful
    params => "" +
      "Registration successful",

    // `registration-terms-and-conditions`:
    // terms & conditions
    params => "" +
      "terms & conditions",

    // `registration-title`:
    // Registration - Eversports
    params => "" +
      "Registration - Eversports",

    // `signin_or`:
    // or
    params => "" +
      "or",

    // `start-now`:
    // Start now
    params => "" +
      "Start now",

    // `tld-country-name`:
    // {tld, select, 
    //  at {Austria} 
    //  de {Germany} 
    //  nl {the Netherlands} 
    //  fr {France} 
    //  ch {Switzerland} 
    //  es {Spain} 
    //  it {Italy} 
    //  be {Belgium} 
    //  other {}}
    params => "" +
      (
        params.tld == "at" ? "" +
          "Austria" :
        params.tld == "de" ? "" +
          "Germany" :
        params.tld == "nl" ? "" +
          "the Netherlands" :
        params.tld == "fr" ? "" +
          "France" :
        params.tld == "ch" ? "" +
          "Switzerland" :
        params.tld == "es" ? "" +
          "Spain" :
        params.tld == "it" ? "" +
          "Italy" :
        params.tld == "be" ? "" +
          "Belgium" :
        ""
      ),

    // `venue-invitation-confirmation`:
    // Accept Invitation
    params => "" +
      "Accept Invitation",

    // `venue-invitation-eversports-info`:
    // By accepting this invitation, you will be able to use your Eversports account to book at {venueName}.
    params => "" +
      "By accepting this invitation, you will be able to use your Eversports account to book at " +
      params.venueName +
      ".",

    // `venue-invitation-greeting`:
    // Hello
    params => "" +
      "Hello",

    // `venue-invitation-heading`:
    // Invitation from {venueName}
    params => "" +
      "Invitation from " +
      params.venueName,

    // `venue-invitation-password-label`:
    // Password
    params => "" +
      "Password",

    // `venue-invitation-rejection`:
    // Decline
    params => "" +
      "Decline",

    // `venue-invitation-set-password`:
    // To accept this invitation please set a password and press the button 'Accept invitation'.
    params => "" +
      "To accept this invitation please set a password and press the button 'Accept invitation'.",

    // `venue-invitation-shared-info`:
    // Eversports gets information about your bookings and products from {venueName} to display them in your Eversports account.
    params => "" +
      "Eversports gets information about your bookings and products from " +
      params.venueName +
      " to display them in your Eversports account.",

    // `venue-invitation-venue-info`:
    // When you book online, {venueName} gets the contact information (name, e-mail, date of birth, address, profile picture) from your Eversports profile to process your bookings.
    params => "" +
      "When you book online, " +
      params.venueName +
      " gets the contact information (name, e-mail, date of birth, address, profile picture) from your Eversports profile to process your bookings.",

    // `we-use`:
    // We use
    params => "" +
      "We use",

    // `week`:
    // week
    params => "" +
      "week",

    // `year`:
    // year
    params => "" +
      "year",

    // `yes`:
    // Yes
    params => "" +
      "Yes",
  ];
};
